// extracted by mini-css-extract-plugin
export var productImage = "_mh-1";
export var viewLink = "_mh-2";
export var wishlistItem = "_mh-0";